import React, { useState, useEffect } from "react";
import { useLocation, Link, useNavigate } from "react-router-dom";
import { IoHome } from "react-icons/io5";
import { AiOutlineUser } from "react-icons/ai";
import { GiBookCover } from "react-icons/gi";
import { MdSettings } from "react-icons/md";

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeLink, setActiveLink] = useState("Users");
  const handleActiveLink = (title) => {
    setActiveLink(title);
  };

  useEffect(() => {
    const allLinks = [
      {
        title: "Profile",
        link: "/profile",
        icon: <AiOutlineUser className="text-xl" />,
      },
      {
        title: "Home",
        link: "/home",
        icon: <IoHome className="text-xl" />,
      },
      {
        title: "Subjects",
        link: "/subjects",
        icon: <GiBookCover className="text-xl" />,
      },
      {
        title: "Mode",
        link: "/mode",
        icon: <MdSettings className="text-xl" />,
      },
    ];
    allLinks.forEach((link) => {
      if (location.pathname.includes("/subjects")) {
        setActiveLink("Subjects");
      } else {
        if (location.pathname.includes(link.link)) {
          setActiveLink(link.title);
        }
      }
    });
  }, [location]);

  const handleLogout = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("user");
    navigate("/");
  };

  return (
    <div className="w-[18%] md:block hidden h-[100vh] bg-white py-4 px-2 fixed top-0 shadow-lg">
      <div className=" min-h-[100vh] relative ">
        <div className="min-w-full h-full flex flex-col gap-1 justify-between items-center">
          <Link
            to={"/home"}
            className={`${
              activeLink === "Home"
                ? "bg-[#1e88e5]  text-white"
                : "text-white bg-[#5faff4]"
            } text-[16px] font-hind text-left hover:bg-[#1e88e5] font-medium rounded-lg py-2 w-full flex justify-between items-center  px-4`}
            onClick={() => handleActiveLink("Home")}
          >
            Home
            <IoHome className="text-xl" />
          </Link>
          <Link
            to={"/profile"}
            className={`${
              activeLink === "Profile"
                ? "bg-[#1e88e5]   text-white"
                : "text-white bg-[#5faff4]"
            } text-[16px] font-hind hover:bg-[#1e88e5] text-left rounded-lg font-medium py-2 w-full flex justify-between items-center px-4 `}
            onClick={() => handleActiveLink("Profile")}
          >
            Profile <AiOutlineUser className="text-xl" />
          </Link>
          <Link
            to={"/subjects"}
            className={`${
              activeLink === "Subjects"
                ? "bg-[#1e88e5]   text-white"
                : "text-white bg-[#5faff4]"
            } text-[16px] font-hind hover:bg-[#1e88e5] text-left rounded-lg font-medium py-2 w-full flex justify-between items-center px-4 `}
            onClick={() => handleActiveLink("Subjects")}
          >
            Subjects <GiBookCover className="text-xl" />
          </Link>
          <Link
            to={"/mode"}
            className={`${
              activeLink === "Mode"
                ? "bg-[#1e88e5]   text-white"
                : "text-white bg-[#5faff4]"
            } text-[16px] font-hind hover:bg-[#1e88e5] text-left rounded-lg font-medium py-2 w-full flex justify-between items-center px-4 `}
            onClick={() => handleActiveLink("Mode")}
          >
            Mode <GiBookCover className="text-xl" />
          </Link>
        </div>
        <div className="w-full flex flex-col gap-2 justify-between items-center absolute bottom-5">
          <button
            className=" text-[#666666] text-[16px] font-hind flex justify-start gap-2 items-center font-medium py-2 w-full  px-4 rounded-lg hover:bg-white  hover:animate-bounce"
            onClick={handleLogout}
          >
            <img src="/logout.svg" alt="logout" className="w-5 h-5" />
            Logout
          </button>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
